import { render } from "./Subtitle.vue?vue&type=template&id=1b11f862&scoped=true"
const script = {}

import "./Subtitle.vue?vue&type=style&index=0&id=1b11f862&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b11f862"],['__file',"src/views/pre/survey/components/Subtitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b11f862"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b11f862', __exports__)) {
    console.log('reload')
    api.reload('1b11f862', __exports__)
  }
  
  module.hot.accept("./Subtitle.vue?vue&type=template&id=1b11f862&scoped=true", () => {
    console.log('re-render')
    api.rerender('1b11f862', render)
  })

}


export default __exports__